import { createApi } from "@reduxjs/toolkit/query/react";
import { DynamicBaseQuery } from "./baseQuery";
import { RolesResponse } from "./types/roles/responses/RolesResponse";
import { PermissionResponse } from "./types/permissions/responses/PermissionsResponse";
import { CreateRoleRequest } from "./types/roles/requests/CreateRoleRequest";
import { RoleParentModel } from "./types/roles/models/RoleParentModel";
import { DeleteRoleRequest } from "./types/roles/requests/DeleteRoleRequest";
import { SuccessResponse } from "./types/common/responses/SuccessResponse";

export const rolesApi = createApi({
  reducerPath: "rolesApi",
  baseQuery: DynamicBaseQuery,
  tagTypes: ["Roles-User", "Permissions-User"],
  endpoints: (builder) => ({
    getAllRoles: builder.query<RolesResponse, void>({
      query: () => ({
        url: "/roles",
        method: "GET",
      }),
      providesTags: ["Roles-User"],
    }),
    getRolesList: builder.query<RolesResponse, void>({
      query: () => ({
        url: "/roles/list",
        method: "GET",
      }),
      providesTags: ["Roles-User"],
    }),
    getAllPermissions: builder.query<PermissionResponse, void>({
      query: () => ({
        url: "/permissions",
        method: "GET",
      }),
      providesTags: ["Permissions-User"],
    }),
    createRole: builder.mutation<RoleParentModel, CreateRoleRequest>({
      query: (body) => ({
        url: "/roles",
        method: "POST",
        body,
      }),
    }),
    updateRole: builder.mutation<
      RoleParentModel,
      { role: number; body: CreateRoleRequest }
    >({
      query: ({ role, body }) => ({
        url: `/roles/${role}`,
        method: "PUT",
        body,
      }),
    }),
    deleteRole: builder.mutation<
      SuccessResponse,
      { role: number; body: DeleteRoleRequest }
    >({
      query: ({ role, body }) => ({
        url: `/roles/${role}`,
        method: "DELETE",
        body,
      }),
    }),
  }),
});
export const {
  useGetAllRolesQuery,
  useGetRolesListQuery,
  useGetAllPermissionsQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = rolesApi;
